import React from "react";

import Navbar from "./Navbar";
import Home from "./Home";
import OurStories from "./OurStories";
import ImpactNumbers from "./ImpactNumbers";
import FAQs from "./FAQs";
import Footer from "./Footer";

const Landing = () => {
  return (
    <div
      className="bg-[#F7F7F8] flex items-center justify-center w-full flex-col"
      style={{ fontFamily: "Inter" }}
    >
      <Navbar />
      <div className="container-md">
        <section
          id="home"
          className="mt-[70px] py-6 flex  justify-between w-full items-center"
        >
          <Home />{" "}
        </section>
        <section id="stories" className="">
          <OurStories />{" "}
        </section>
      </div>
      <section
        id="impact"
        className=" bg-white w-full flex p-3 justify-center items-center  0"
      >
        <ImpactNumbers />{" "}
      </section>
      <section
        id="faqs"
        className="bg-white flex w-full p-3 justify-center items-center  0"
      >
        <FAQs />{" "}
      </section>
      <Footer />{" "}
    </div>
  );
};

export default Landing;
